import { render, staticRenderFns } from "./PaypaIcon.vue?vue&type=template&id=ed0cb4ea&"
import script from "./PaypaIcon.vue?vue&type=script&lang=js&"
export * from "./PaypaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports